<template>
  <div>
    <div class="new-left"></div>
    <div class="new-center">
      <div style="position: relative">
        <el-image
          lazy
          class="new-banner"
          :src="require('@/assets/images/bg2.png')"
        ></el-image>
        <div class="new-tips">
          <div class="tips1" @click="gohome">首页</div>
          <div class="tips2">
            <div
              class="tips-item"
              :class="bannerTipsIndex == index ? 'tips-item-click' : ''"
              v-for="(item, index) in bannerTipsList"
              :key="index"
              @click="bannerTipsClick(item,index)"
            >
              {{ item.projectTypeName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-right"></div>
  </div>
</template>

<script>
export default {
  name: "bannerTips",
  props: ["bannerTipsList", "bannerIndex"],
  // props: {
  //   bannerTipsList: {
  //     type: Array
  //   },
  //   bannerIndex: {
  //     default: 0
  //   }
  // },

  data() {
    return {
      bannerTipsIndex: 0,
    };
  },
  created() {
    this.bannerTipsIndex = this.bannerIndex;
    // this.bannerTipsIndex = localStorage.getItem('lobannerIndex')
  },

  mounted() {
    const that = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "lobannerIndex") {
        that.lobannerIndex = e.newValue;

        that.bannerTipsIndex = e.newValue;
      }
    });
  },
  methods: {
    bannerTipsClick(row,index) {
      this.bannerTipsIndex = index;
      this.$emit("changeTips", index);
    },
    gohome(){
      this.$router.push('/')
    },
  },
};
</script>

<style scoped lang="less">
.news-content {
  margin-top: 20px;
  width: 100%;
  height: 100vh;
  display: flex;
  background-color: pink;

  .new-left {
    flex: 1;
    background: sandybrown;
  }

  .new-center {
    flex: 5.3;
    background: #f4f4f4;

    .new-banner {
      width: 100%;
      height: 289px;
    }

    .new-tips {
      width: 100%;
      height: 54px;
      line-height: 54px;
      background: #ffffff;
      padding-left: 30px;
      padding-right: 20px;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      bottom: 4px;
      display: flex;
      justify-content: space-between;

      .tips1{
      font-size: 14px;
      color: #858585;
      cursor: pointer;
      }
      .tips2{

        display: flex;
        justify-content: space-between;
      }

      .tips-item {
        height: 52px;
        font-size: 14px;
        font-weight: 500;
        color: #666666;
        font-weight: 400;
        cursor: pointer;
        margin: 0 10px;
      }
      .tips-item-click {
        // border-bottom: 2px solid #2A5E90;
        font-weight: bold;
        color: #185da0;
      }
    }
  }

  .new-right {
    flex: 1;
    background: sandybrown;
  }
}

// @media only screen and (max-width: 1500px) {
//   .new-left {
//     flex: 1 !important;
//     background: sandybrown;
//   }

//   .new-center {
//     flex: 15 !important;

//     background: #F4F4F4;
//   }

//   .new-right {
//     flex: 1 !important;
//     background: sandybrown;
//   }
// }
</style>
